// extracted by mini-css-extract-plugin
module.exports = {"root":"AvatarPopover_root__2UQj7","miniProfile":"AvatarPopover_miniProfile__2ayuA"};